export interface ProductionProcessDetails {
  id: string;
  description: string;
  external: boolean;
  allowReProcess: boolean;
  productionProcessTypeId: string;
  obsolete: boolean;
  showOnJobSchedule: boolean;
  disallowOnStop: boolean;
  disallowOnProforma: boolean;
  inLocationId: string;
  outLocationId: string;
  requirementIsProduct: boolean;
  useStockLocations: boolean;
  allowPartIssue: boolean;
}
